import { render } from "./SliderMenu.vue?vue&type=template&id=131fb8c2"
import script from "./SliderMenu.vue?vue&type=script&lang=js"
export * from "./SliderMenu.vue?vue&type=script&lang=js"

import "./SliderMenu.vue?vue&type=style&index=0&id=131fb8c2&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__